import { render, staticRenderFns } from "./common-safe.vue?vue&type=template&id=082aa3c2&scoped=true&"
import script from "./common-safe.vue?vue&type=script&lang=ts&"
export * from "./common-safe.vue?vue&type=script&lang=ts&"
import style0 from "./common-safe.vue?vue&type=style&index=0&id=082aa3c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082aa3c2",
  null
  
)

export default component.exports